import React from 'react';

const colors = {
  darkTeal: '#416E72',
  teal: '#5B979A',
  lightestTeal: '#D9F0EE',
  nearBlack: '#181815',
  darkGray: '#353433',
  white: '#FFFFFF',
  error: '#c53030',
  errorLight: '#fed7d7',
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleRefresh = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: colors.lightestTeal,
          fontFamily: 'Inter, sans-serif',
          padding: '20px',
        }}>
          <div style={{
            backgroundColor: colors.white,
            borderRadius: '12px',
            padding: '40px',
            maxWidth: '500px',
            textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          }}>
            <div style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: colors.errorLight,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
            }}>
              <span style={{ fontSize: '28px' }}>!</span>
            </div>

            <h1 style={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: '24px',
              color: colors.nearBlack,
              marginBottom: '12px',
            }}>
              Something went wrong
            </h1>

            <p style={{
              color: colors.darkGray,
              fontSize: '15px',
              lineHeight: '1.6',
              marginBottom: '24px',
            }}>
              We encountered an unexpected error. Your form data may not have been saved.
              Please try refreshing the page or start over.
            </p>

            <div style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}>
              <button
                onClick={this.handleRefresh}
                style={{
                  padding: '12px 24px',
                  backgroundColor: colors.teal,
                  color: colors.white,
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '15px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  fontFamily: 'Inter, sans-serif',
                }}
              >
                Refresh Page
              </button>
              <button
                onClick={this.handleGoHome}
                style={{
                  padding: '12px 24px',
                  backgroundColor: 'transparent',
                  color: colors.teal,
                  border: `1px solid ${colors.teal}`,
                  borderRadius: '6px',
                  fontSize: '15px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  fontFamily: 'Inter, sans-serif',
                }}
              >
                Go to Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
